import React from 'react';

const FilterListIcon = () => (
  <svg width="24" height="24" className="rect" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="5" y="7" width="14" height="2" rx="1" fill="#787F88" />
    <rect x="7" y="11" width="10" height="2" rx="1" fill="#787F88" />
    <rect x="10" y="15" width="4" height="2" rx="1" fill="#787F88" />
  </svg>
);

export default FilterListIcon;
